<template>
  <vonap-window
    transition="dialog-scale-transition"
    v-model="assignToClientModalVisible"
    title="Assign Users To Client."
    width="782px"
    height="432px"
    :modal="true"
    @close="close"
  >
    <v-layout row justify-center>
      <v-card class="mx-auto">
        <v-card-text>
          <v-container class="py-0 px-1">
            <v-layout wrap>
              <v-flex d-flex xs12>
                <div>
                  <page-toolbar>
                    <kendo-button
                      icon="check"
                      title="Add Users to Client."
                      @click="addUsersToClient"
                    >
                    </kendo-button>
                  </page-toolbar>
                  <kendo-grid
                    ref="userGrid"
                    :data-source="this.dataSource"
                    height="320px"
                    :editable="false"
                    :filterable="true"
                    :sortable="true"
                    :scrollable="true"
                    :pageable="false"
                    :pageable-always-visible="false"
                    :columns="gridColumns"
                  >
                  </kendo-grid>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-layout>
  </vonap-window>
</template>
<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import PageToolbar from '@/components/PageToolbar'
import VonapWindow from '@/components/VonapWindow'
import notification from '@/helpers/notification'
import confirmationWindow from '@/helpers/confirmation-window'

export default {
  name: 'AssignToClientForm',
  components: {
    PageToolbar,
    VonapWindow,
  },
  props: {
    assignToClientModalVisible: Boolean,
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async addUsersToClient() {
      const grid = this.$refs.userGrid.kendoWidget()
      const selectedUsersIds = grid.selectedKeyNames().map(id => +id)

      if (selectedUsersIds.length == 0) {
        notification('Select a user to assign to client.', 'error')
      } else {
        const message = `Are you sure you want to assign ${selectedUsersIds.length} user${
          selectedUsersIds.length > 1 ? 's' : ''
        } to this client ?`
        const vm = this
        confirmationWindow.openConfirmationWindow('Confirmation', message, async () => {
          await axios({
            url: '/api/accounts/assignUsersToClient',
            method: 'post',
            params: {
              usersIds: selectedUsersIds,
              clientId: vm.clientId,
            },
            headers: {'Content-Type': 'multipart/form-data'},
          })
          grid.dataSource.read()
          vm.$emit('save')
        })
      }
    },
    reloadGrid() {
      const grid = this.$refs.userGrid.kendoWidget()
      grid.dataSource.read()
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    dataSource() {
      return new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        transport: {
          read: {
            type: 'GET',
            dataType: 'json',
            url: '/api/accounts/getUsersToAssign',
            data: () => ({clientId: this.clientId}),
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'userId',
            fields: {
              userId: {type: 'string'},
              userName: {type: 'string'},
              email: {type: 'string'},
              role: {type: 'string'},
              defaultClient: {type: 'string'},
            },
          },
        },
      })
    },
    gridColumns: function() {
      let columns = [
        {selectable: true, width: 38, attributes: {style: 'text-align: center;'}},
        {
          field: 'email',
          title: 'Email',
          width: 232,
        },
        {field: 'role', title: 'Role', width: 114},
        {field: 'defaultClient', title: 'Default Client', width: 182},
      ]
      return columns
    },
  },
}
</script>
